






























































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class ElWeekPicker extends Vue {
	@Prop({
		type: [Number, Array],
		default: () => {
			return [];
		}
	})
	value!: number | Array<number>;
	@Prop({ type: String, default: "range" }) type!: string;
	@Prop({ type: String, default: "medium" }) size!: string;
	@Prop({ type: String, default: "周" }) prefix!: string;
	@Prop({ type: String, default: "开始星期" }) startPlaceholder!: string;
	@Prop({ type: String, default: "结束星期" }) endPlaceholder!: string;

	popoverVisible: boolean = false;
	today: string = this.$format(new Date(), "YYYY年 MM月 DD日");
	day: string = this.$format(new Date(), "d");
	week: Array<string> = ["一", "二", "三", "四", "五", "六", "日"];

	start: number = -1;
	end: number = -1;
	vStart: number = -1;
	vEnd: number = -1;

	@Watch("value")
	onValueChange() {
		if (this.type == "range") {
			if (this.value && (this.value as Array<number>).length) {
				const [sIndex, eIndex] = Array.from(this.value as any);
				this.start = sIndex;
				this.end = eIndex;
			}
		} else {
			if (this.value && this.value >= 0) {
				this.start = this.end = Number(this.value);
			}
		}
		this.start = -1;
		this.end = -1;
	}

	get startValue() {
		if (this.start >= 0 && this.end >= 0) {
			return this.prefix + this.week[this.start];
		}
		return null;
	}

	get endValue() {
		if (this.start >= 0 && this.end >= 0) {
			return this.prefix + this.week[this.end];
		}
		return null;
	}

	mounted() {
		this.onValueChange();
	}

	updateHandler() {
		this.$nextTick(() => {
			this.vStart = this.vEnd = -1;
			if (this.type == "range" && this.value) {
				const ary: Array<number> = Array.from(this.value as any);
				const sIndex: number = ary.shift() as number;
				const eIndex: number = ary.pop() as number;
				this.start = sIndex >= 0 ? sIndex : -1;
				this.end = eIndex >= 0 ? eIndex : -1;
			} else if (this.value) {
				const sIndex: number = Number(this.value);
				this.start = sIndex >= 0 ? sIndex : -1;
				this.end = sIndex >= 0 ? sIndex : -1;
			} else {
				this.start = -1;
				this.end = -1;
			}
			this.vStart = this.start;
			this.vEnd = this.end;
		});
	}

	overHandler(index: number) {
		if (this.start >= 0 && this.end < 0) {
			this.vEnd = Math.max(index, this.start);
			this.vStart = Math.min(index, this.start);
		}
	}

	clickHander(index: number) {
		if (this.type == "range") {
			if ((this.start >= 0 && this.end >= 0) || this.start < 0) {
				this.vStart = index;
				this.vEnd = index;
				this.start = index;
				this.end = -1;
			} else if (this.start >= 0 && this.end < 0) {
				this.start = this.vStart;
				this.end = this.vEnd;

				if(this.start == this.end){
					this.$emit("input", [this.start, this.end]);
				}else{
					this.$emit(
						"input",
						new Array(this.end - this.start + 1)
							.fill(this.start)
							.map((item, index) => item + index)
					);
				}

				this.updateHandler();
				this.closeHandler();
			}
		} else {
			this.start = index;
			this.end = index;
			this.vStart = -1;
			this.vEnd = -1;
			this.$emit("input", index);
			this.updateHandler();
			this.closeHandler();
		}
	}

	deleteHandler() {
		this.start = -1;
		this.end = -1;
		this.vStart = -1;
		this.vEnd = -1;
		if (this.type == "range") {
			this.$emit("input", []);
			this.updateHandler();
		} else {
			this.$emit("input", null);
			this.updateHandler();
		}
	}

	closeHandler() {
		if (!this.popoverVisible) return;
		this.popoverVisible = false;
	}
}
